export const getImage = async (src: string, invert: boolean) => {
  const image = new Image();
  image.src = src;
  await image.decode();

  if (!invert) {
    return image;
  }

  // invert image color
  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d');
  if (!ctx) {
    throw new Error('Failed to create canvas context');
  }
  canvas.width = image.width;
  canvas.height = image.height;

  if (ctx.filter) {
    ctx.filter = 'invert(1)';
    ctx.drawImage(image, 0, 0);
  } else {
    ctx.drawImage(image, 0, 0);
    ctx.globalCompositeOperation = 'difference';
    if (ctx.globalCompositeOperation === 'difference') {
      ctx.fillStyle = 'white';
      ctx.fillRect(0, 0, image.width, image.height);
      const canvas2 = document.createElement('canvas');
      const ctx2 = canvas2.getContext('2d')!;
      canvas2.width = image.width;
      canvas2.height = image.height;
      ctx2.drawImage(image, 0, 0);
      ctx2.globalCompositeOperation = 'source-in';
      ctx2.fillStyle = 'black';
      ctx2.fillRect(0, 0, image.width, image.height);
      ctx.globalCompositeOperation = 'destination-in';
      ctx.drawImage(canvas2, 0, 0);
    } else {
      try {
        const imageData = ctx.getImageData(0, 0, image.width, image.height);
        const { data } = imageData;
        for (let i = 0; i < data.length; i += i % 4 === 2 ? 2 : 1) {
          data[i] = 255 - data[i];
        }
        ctx.putImageData(imageData, 0, 0);
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
      }
    }
  }
  return canvas;
};
